// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bmV7","content":"styles_content__250XW"};